import React from 'react';

function RoutesWhite(props) {
  return (
    <svg viewBox="0 0 28 28" {...props}>
      <g fill="#FFF" fillRule="evenodd">
        <circle strokeOpacity={0.4} stroke="#FFF" opacity={0.2} cx={14} cy={14} r={6} />
        <path d="M14 8c3.308 0 6 2.692 6 6s-2.692 6-6 6-6-2.692-6-6 2.692-6 6-6zm2.722 3.615a.25.25 0 00-.337-.337l-6.25 3.25a.25.25 0 00.115.472H13v2.75a.25.25 0 00.471.116l3.25-6.25z" />
      </g>
    </svg>
  );
}

export default RoutesWhite;
